import { render, staticRenderFns } from "./grid-popover-element.vue?vue&type=template&id=2e119471"
import script from "./grid-popover-element.ts?vue&type=script&lang=js&external"
export * from "./grid-popover-element.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports